import {Layers, RockBottomLayers, SimpleStageLayer} from "./RockBottomLayers";
import {RockBottomGameConfig} from "../RockBottomGameConfig";
import {SpinePlayer} from "../../core/utils/SpinePlayer";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {RockBottom} from "../RockBottom";
import {gsap} from "gsap";
import {RockBottomFreeSpinView} from "./RockBottomFreeSpinView";
import {RockBottomParsedInitData} from "../server/data/RockBottomParsedInitData";
import {RockBottomParsedGameData} from "../server/data/RockBottomParsedGameData";
import {RockBottomSound} from "../sound/RockBottomSound";

export class DrinkAnimView extends PIXI.Container {
    private _layer: SimpleStageLayer | undefined;
    private _levelUpAnim: SpinePlayer[] = [];
    private _overlay: PIXI.Graphics;
    private _plusTwoImage: PIXI.Sprite;

    constructor() {
        super();
        this.init();
        this.onResize();
    }

    public playDrinkAnimation(animName: string): gsap.core.Timeline {
        const parsedData: RockBottomParsedInitData | RockBottomParsedGameData = RockBottom.getParsedData();
        const tl: gsap.core.Timeline = gsap.timeline(),
            animIndex: number = RockBottomGameConfig.MID_SYMS.indexOf(animName) - 1,
            spineAnim: SpinePlayer = this._levelUpAnim[animIndex];

        //#271
        tl.to(this, {duration: 0.3});

        tl.add(spineAnim.play({
            name: "animation",
            loop: false,
            onStart: () => {
                spineAnim.visible = true;
                this._overlay.visible = true;
                this.showExtraTwoSpin();
                RockBottom.freeSpinView.playEmptyBottleAnim();
                RockBottom.background.updateLevelUpTint(true);
                RockBottomSound.fadeMusic(0, 0.1);
                RockBottomSound.soundPlayer.playTrack({name: RockBottomSound.BONUS_GAME_LEVEL_CHANGE_DRINK})
            },
            onComplete: () => {
                spineAnim.visible = false;
                this._overlay.visible = false;
                RockBottom.freeSpinView.setActivePolaroid(true);
                RockBottom.freeSpinView.updateBottleLevel(undefined, true);
                RockBottomFreeSpinView.freespinSounds(parsedData.fsLevelNextSpin);
            }
        }));

        tl.to(this, {duration: 0.3});

        return tl;
    }

    private init(): void {
        this._layer = RockBottomLayers.getLayer(Layers.ACTIVE_SILHOUETTE);
        this.createOverlay();
        this.createSpine();
        this.createPlusTwoGraphics();
        this._layer?.addChild(this);
    }

    private createSpine(): void {
        for (let i: number = 1; i < RockBottomGameConfig.MID_SYMS.length; i++) {
            const spineObj: SpinePlayer = new SpinePlayer("levelUp" + RockBottomGameConfig.MID_SYMS[i]);
            spineObj.position.set(360, 360);
            spineObj.name = "levelUp" + RockBottomGameConfig.MID_SYMS[i];
            this._levelUpAnim.push(spineObj);
            this.addChild(spineObj);
        }
    }

    private createPlusTwoGraphics(): void {
        this._plusTwoImage = new PIXI.Sprite(RockBottom.assetLoader.getTextures("plusTwoSpin")[0]);
        this._plusTwoImage.anchor.set(0.5);
        this._plusTwoImage.alpha = 0;
        this._plusTwoImage.name = "plusTwoSpinImage";
        this.addChild(this._plusTwoImage);
    }

    private createOverlay(): void {
        this._overlay = new PIXI.Graphics();
        this._overlay.visible = false;
        this.setOverlayProps();
        this.addChild(this._overlay);
    }

    private onResize(): void {
        this.setOverlayProps();
    }

    private setOverlayProps(): void {
        const bounds: ScreenBounds = NolimitApplication.screenBounds;
        this._overlay.clear();
        this._overlay.beginFill(0x000000, 0.75);
        this._overlay.drawRect(bounds.left, bounds.top, bounds.width, bounds.height);
        this._overlay.endFill();
    }

    private showExtraTwoSpin(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline(),
            pos: PIXI.Point = RockBottom.keypadPlugin.getSpinButtonCenter(),
            isLandscape: boolean = NolimitApplication.isLandscape,
            posXMargin: number = isLandscape ? 40 : 0,
            posYMargin: number = 50;

        this._plusTwoImage.position.set(pos.x + posXMargin, pos.y + posYMargin);
        this._plusTwoImage.scale.set(0.4);

        tl.to(this._plusTwoImage, 0.3, {alpha: 1, delay: 0.3});
        RockBottomSound.playTrack(RockBottomSound.BONUS_GAME_SPIN_COUNT_2);
        tl.to(this._plusTwoImage, 0.7, {
            y: pos.y - 150,
            onStart: () => {
                gsap.to(this._plusTwoImage.scale, 0.7, {x: 1, y: 1});
                RockBottom.freeSpinView.updateSpinsCounter(RockBottom.model.data.freespinsLeft);
            }
        });
        tl.to(this._plusTwoImage, 0.1, {alpha: 0});

        return tl;
    }
}